import axios from 'axios';
import * as CookieService from '../Cookie/CookieService';

const path = '/api/v1';

export function getAdminHomeworkList() {
    return axios.get(path.concat('/teacherhomeworks'), CookieService.setHeaders());
}

export function getHomeworkList(className, subject, search, pageVO) {
    let setParam = path.concat('/homeworkpaging?');
    if (className != undefined) {
        setParam += 'className=' + className;
    }
    if (subject != undefined) {
        setParam += (className == undefined) ? 'subject=' + subject : '&subject=' + subject;
    }

    if (search != undefined)
        setParam += '&userName=' + search;

    if (className == undefined && subject == undefined)
        setParam += 'page=' + pageVO.page + '&size=' + pageVO.size + '&sort=' + pageVO.sortBy + ',' + pageVO.direction;
    else
        setParam += '&page=' + pageVO.page + '&size=' + pageVO.size + '&sort=' + pageVO.sortBy + ',' + pageVO.direction;

    console.log(setParam);
    return axios.get(setParam, CookieService.setHeaders());
}

export function getVocabList(grade, section, title, english, pageVO) {
    let setParam = path.concat('/vocabularies?');
    if (grade != null && !grade.trim().isEmpty) {
        setParam += 'grade=' + grade;
        if (section != null && !section.trim().isEmpty) {
            setParam += '&section=' + section;
            if (title != null && !title.trim().isEmpty) {
                setParam += '&title=' + title;
            }
        }
    }

    if (english != null && !english.trim().isEmpty)
        setParam += "&english=" + english;
    setParam += '&page=' + pageVO.page + '&size=' + pageVO.size + '&sort=' + pageVO.sortBy + ',' + pageVO.direction;
    //console.log(setParam);
    return axios.get(setParam, CookieService.setHeaders());
}

export function getVocabCategoryList(grade, section) {
    let setParam = path.concat('/vocabularies/category?');
    if (grade != null && !grade.trim().isEmpty) {
        setParam += 'grade=' + grade;
        if (section != null && !section.trim().isEmpty) {
            setParam += '&section=' + section;
        }
    }
    return axios.get(setParam, CookieService.setHeaders());
}

export function getReadingCategoryList(grade, section) {
    let setParam = path.concat('/reading/category?');
    if (grade != null && !grade.trim().isEmpty) {
        setParam += 'grade=' + grade;
        if (section != null && !section.trim().isEmpty) {
            setParam += '&section=' + section;
        }
    }
    return axios.get(setParam, CookieService.setHeaders());
}

export function updateVocabulary(id, english, korean) {
    const requestParams = {
        params: {
            "id": id,
            "english": english,
            "korean": korean,
        },
        headers: CookieService.setHeader()
    };
    return axios.get(path.concat('/vocabulary/update'), requestParams);
}

export async function saveVocabulary(formData) {
    await axios.post(path.concat('/vocabulary/upload'), formData, CookieService.setHeaders());
}

export function getHomeworklastIndex(studentName, subject, grade, section, title) {
    const requestParams = {
        params: {
            "studentName": studentName,
            "subject": subject,
            "grade": grade,
            "section": section,
            "title": title
        },
        headers: CookieService.setHeader()
    };
    console.log(requestParams.params);
    return axios.get(path.concat('/homework/last/index'), requestParams);
}

export function getVocabsCount(grade, section, title) {
    let setParam = path.concat('/vocabularies/count?');
    if (grade != null && !grade.trim().isEmpty) {
        setParam += 'grade=' + grade;
        if (section != null && !section.trim().isEmpty) {
            setParam += '&section=' + section;
            if (title != null && !title.trim().isEmpty) {
                setParam += '&title=' + title;
            }
        }
    }
    return axios.get(setParam, CookieService.setHeaders());
}

export function getReadingCount(grade, section, title) {
    let setParam = path.concat('/reading/count?');
    if (grade != null && !grade.trim().isEmpty) {
        setParam += 'grade=' + grade;
        if (section != null && !section.trim().isEmpty) {
            setParam += '&section=' + section;
            if (title != null && !title.trim().isEmpty) {
                setParam += '&title=' + title;
            }
        }
    }
    return axios.get(setParam, CookieService.setHeaders());
}

export function insertHomework(homework, students, classroomName, dayList, startDate, endDate) {
    let setParam = path.concat('/homework?studentNames=').concat(students);
    setParam += '&classroomName=' + classroomName;
    if (dayList != null && dayList.length > 0) setParam += "&dailyList=" + dayList + "&startDate=" + startDate + "&endDate=" + endDate;
    return axios.post(setParam, homework, CookieService.setHeaders());
}

export function updateHomework(homework, student) {
    let setParam = path.concat('/homework?studentName=').concat(student);
    return axios.put(setParam, homework, CookieService.setHeaders());
}

export function deleteHomework(id) {
    const requestParams = {
        params: {"homeworkId": id},
        headers: CookieService.setHeader()
    };
    return axios.delete(path.concat('/homework'), requestParams);
}

export function deleteHomeworks(ids) {
    const requestParams = {
        params: {"homeworkIds": ids},
        headers: CookieService.setHeader()
    };
    return axios.delete(path.concat('/homeworks'), requestParams);
}

export function getHomeworkLastIndex(students, grade, section, title, subject) {
    const requestParams = {
        params: {
            "studentNames": students,
            "subject": subject,
            "grade": grade,
            "section": section,
            "title": title,
        },
        headers: CookieService.setHeader()
    };
    console.log(requestParams);
    return axios.get(path.concat('/homework/last/index'), requestParams);
}

export function saveReading(reading) {
    return axios.post(path + '/reading', reading, CookieService.setHeaders());
}

export function getReadingList() {
    return axios.get(path + '/reading', CookieService.setHeaders());
}


// WEBPACK FOOTER //
// ./src/services/Teacher/AdminHomeworkService.js